import { render, staticRenderFns } from "./OrderFilterMenu.vue?vue&type=template&id=a0f4237c&scoped=true&"
import script from "./OrderFilterMenu.vue?vue&type=script&lang=js&"
export * from "./OrderFilterMenu.vue?vue&type=script&lang=js&"
import style0 from "./OrderFilterMenu.vue?vue&type=style&index=0&id=a0f4237c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f4237c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0f4237c')) {
      api.createRecord('a0f4237c', component.options)
    } else {
      api.reload('a0f4237c', component.options)
    }
    module.hot.accept("./OrderFilterMenu.vue?vue&type=template&id=a0f4237c&scoped=true&", function () {
      api.rerender('a0f4237c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Orders/components/OrderFilterMenu.vue"
export default component.exports